/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EnforcementSignalSkuEnum = 'VM' | 'TiB';

export const EnforcementSignalSkuEnum = {

    VM: 'VM' as EnforcementSignalSkuEnum,

    TI_B: 'TiB' as EnforcementSignalSkuEnum
};

